// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import FavoritesExpeditors from './FavoritesExpeditors';

export default compose(
    connect(
        state => ( {
            user: state?.global?.user || {},
        } ),
        dispatch => ( {} ),
    ),
)( FavoritesExpeditors );
